export class RBImage {

  public id: number;
  public type: string;
  public mime: string;
  public dida: string;
  public note: string;
  public portrait: number;
  public width: number;
  public height: number;
  public img64: string;

  constructor(rawImage: any) {
    this.id = rawImage.id;
    this.type = rawImage.type;
    this.mime = rawImage.mime;
    this.dida = rawImage.dida;
    this.note = rawImage.note;
    this.portrait = rawImage.portrait;
    this.width = rawImage.w;
    this.height = rawImage.h;
    this.img64 = rawImage.img;
  }

  /**
   * Return image src attribute for an image base64-encoded.
   *
   * @return string
   */
  get src(): string {
    // Decode base64.
    let decodedBase64 = atob(this.img64);
    let src = 'data:' + this.mime +   ';base64, ' + decodedBase64;

    return src;
  }

  /**
   * Return image html element.
   *
   * @return string
   */
   get html(): string {
    return '<image src="' + this.src + '" alt="' + this.dida +'" title="' + this.dida +'">';
  }

}

